import * as React from 'react';
import DataTable from 'react-data-table-component';

const columns = [
  {
    selector: 'Timestamp',
    name: 'Timestamp',
    sortable: true,
  },
  {
    selector: 'FarmSensor.air_temp',
    name: 'Air Temperature',
  },
  {
    selector: 'FarmSensor.air_hum',
    name: 'Air Humidity',
  },
  {
    selector: 'FarmSensor.soil_ec',
    name: 'Soil EC',
  },
  {
    selector: 'FarmSensor.soil_temp',
    name: 'Soil Temperature',
  },
  {
    selector: 'FarmSensor.soil_hum',
    name: 'Soil Humidity',
  },
  {
    selector: 'FarmSensor.illuminance',
    name: 'Illuminance',
  },
];

const pagination = true
const paginationPage = 5
const paginationRowsPerPageOptions = [5]

const EnvironmentTable = (rows) => {
  return (
    <div style={{ height: 200, width: '100%' }}>
      <DataTable
        columns={columns}
        data={rows.data}
        pagination={pagination}
        paginationPerPage={paginationPage}
        paginationRowsPerPageOptions={paginationRowsPerPageOptions}
      />
    </div>
  )
}

export default EnvironmentTable